<template>
    <v-layout>
        <v-flex xs12 v-if="loading">
            <v-progress-linear :indeterminate="true"></v-progress-linear>
        </v-flex>
        <v-flex v-if="!loading">
            <v-card flat>
                <v-card-title class="primary headline white--text">
                    Maintenance Record
                    <v-spacer></v-spacer>
                    <date-range-selector v-model="range" @change="refresh"></date-range-selector>
                </v-card-title>
                <v-layout row wrap>
                    <v-flex xs2>
                        <value-box
                                :value="desserts.length"
                                icon=""
                                use-int
                                :title="'Total'">
                        </value-box>

                    </v-flex>
                    <v-flex xs2>
                        <value-box
                                :value="totalFixed"
                                icon=""
                                use-int
                                :title="'Fixed'">
                        </value-box>
                    </v-flex>
                    <v-flex xs2>
                        <value-box
                                :value="totalToMe"
                                icon=""
                                use-int
                                :title="'Assigned to me'">
                        </value-box>
                    </v-flex>
                    <v-flex xs2>
                        <value-box
                                :value="totalByMe"
                                icon=""
                                use-int
                                :title="'Assigned by me'">
                        </value-box>
                    </v-flex>
                    <v-flex xs3>
                        <v-switch class="ml-4" v-model="showMineOnly" v-on:change="refineDeserts" label="Show Mine Only"></v-switch>
                    </v-flex>


                </v-layout>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn class="accent" @click="uploadDialogSwitch = true" :disabled="!$can('update', 'MaintenanceRecord')"><v-icon small class="mr-2">fa-file-excel</v-icon> Bulk Upload Excel</v-btn>
                    <v-btn class="accent" @click="editedItem=null;dialog=true" :disabled="!$can('update', 'MaintenanceRecord')"><v-icon small class="mr-2">fa-plus</v-icon> Add Record</v-btn>
                    <v-btn class="accent" @click="exportMR">
                        <v-icon small class="mr-2">fa-download</v-icon>
                        Download
                    </v-btn>
                    <fault-record-dialog v-model="dialog" :item="editedItem" v-on:doreload="refresh()"></fault-record-dialog>
                </v-card-actions>
                <maintenance-upload-dialog v-model="uploadDialogSwitch" v-if="uploadDialogSwitch"></maintenance-upload-dialog>
        <v-card-text>
            <v-data-table
                    :headers="headers"
                    :items="desserts"
                    class="elevation-1"
            >
      <template v-slot:items="props">
        <td>{{ props.item.maintenance_label }}</td>
        <td class="text-xs-left">{{ props.item.equipment }}</td>
        <td class="text-xs-left">{{ props.item.maintenance_date_from }}</td>
        <td class="text-xs-left">{{ props.item.maintenance_date_to }}</td>
        <td class="text-xs-left">
            <v-icon v-if="props.item.is_fixed" color="success">fa-check</v-icon>
            <v-icon v-else color="warning">fa-times</v-icon>
        </td>
          <td class="text-xs-left">
              <severity-chip v-if="props.item.severity" :value="props.item.severity"></severity-chip>
          </td>
          <td class="text-xs-left">{{ props.item.assigned_to }}</td>
          <td class="text-xs-left">{{ props.item.assigned_by }}</td>
          <td class="text-xs-left">
              <span v-if="props.item.assigned_date&&props.item.assigned_date!=='NaT'">{{ props.item.assigned_date.substring(0,10) }}</span>
          </td>
        <td class="justify-center layout px-0">
            <v-icon
            small
            v-if="props.item.url"
            @click="jumpToLink(props.item.url)"
            class="mr-2"
          >
            fa-chart-line
          </v-icon>
          <v-icon
            small
            class="mr-2"
            @click="$can('update', 'MaintenanceRecord') && editItem(props.item)"
          >
            fa-edit
          </v-icon>
          <v-icon
            small
            @click="$can('update', 'MaintenanceRecord') && deleteItem(props.item)"
          >
            fa-trash
          </v-icon>
        </td>
      </template>
      <template v-slot:no-data>
        <v-btn color="primary" @click="initialize">Refresh</v-btn>
      </template>
    </v-data-table>
        </v-card-text>
    </v-card>
        </v-flex>
    </v-layout>
</template>

<script>
    import _ from 'lodash'
  import ValueBox from '@/components/ValueBox'
  import FaultRecordDialog from '../components/FaultRecordDialog'
  import {getMaintenanceRecords, deleteMaintenanceRecord} from '../helper'
  import MaintenanceUploadDialog from '../components/maintenance/MaintenanceUploadDialog'
    import DateRangeSelector from '../components/DateRangeSelector'
    import {exportCSV} from '../tocsv'
    import moment from 'moment'
    import SeverityChip from "../components/SeverityChip";

  export default {
    name: 'MaintenanceRecord',
    components: { MaintenanceUploadDialog, FaultRecordDialog, ValueBox,DateRangeSelector,SeverityChip },
      props: {
          dashboardMode:{type:Boolean,default:false}
      },
      beforeMount() {
          // popular with query
          let maxDate=this.$store.state.pointsListStore.pointsList.data_max_date;
          let rangeStart = _.get(this.$route.query,'rangeStart', null)
          let rangeEnd =  _.get(this.$route.query,'rangeEnd', null)
          if (!!rangeStart) {
              this.range = {start: rangeStart, end: rangeEnd}
          } else if(maxDate){
              this.range={
                  start: moment(maxDate).subtract(30, "days").format('YYYY-MM-DD HH:mm:ss'),
                  end: moment(maxDate).format('YYYY-MM-DD HH:mm:ss')
              }
          }
      },
      computed:{
        totalFixed(){
            return _.filter(this.desserts, function(x) {
                return (x.is_fixed)
            }).length
        },
          totalToMe(){
            return(this.desserts.filter(x=>x.assigned_to==this.username).length)
          },
          totalByMe(){
              return(this.desserts.filter(x=>x.assigned_by==this.username).length)
          },
          username () {
              if (this.$store.state.userStore.user) {
                  return this.$store.state.userStore.user.content.user_name
              }
              return null;
          },
      },
    data(){
        return{
      uploadDialogSwitch: false,
            range: {start: moment().subtract(30, "days").format('YYYY-MM-DD'), end: moment().format('YYYY-MM-DD')},
      dialog: false,
        loading: true,
        showMineOnly:_.get(this.$route.query, 'showMineOnly', false),
      headers: [
        {
          text: 'Fault ',
          align: 'left',
          sortable: true,
          value: 'name'
        },
        { text: 'Equipment ', value: 'equipment' },
        { text: 'Date From ', value: 'maintenance_date_from' },
        { text: 'Date To ', value: 'maintenance_date_to' },
        { text: 'Fixed ', value: 'is_fixed' },
        { text: 'Severity ', value: 'severity' },
        { text: 'Assigned to ', value: 'assigned_to' },
        { text: 'Assigned by ', value: 'assigned_by' },
        { text: 'Assigned date ', value: 'assigned_date' },
        { text: 'Actions ', value: 'name', sortable: false }
      ],
      desserts: [],
      rawDesserts: [],
      editedIndex: -1,
      editedItem: {
      },
      defaultItem: {
        name: '',
        calories: 0,
        fat: 0,
        carbs: 0,
        protein: 0
      }
    }},
    mounted () {
      this.refresh()

    },


    methods: {
      jumpToLink (url) {
        this.$router.push(url)
      },

      initialize () {
        this.refresh()
      },

      editItem (item) {
        this.editedIndex = this.desserts.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.dialog = true
      },

      async deleteItem (item) {
        const index = this.desserts.indexOf(item)
        if (confirm('Are you sure you want to delete this item?') ){
          this.desserts.splice(index, 1)
          await deleteMaintenanceRecord({
            'maintenance_id': item.maintenance_id
          })
          this.refresh()
        }
      },

      close () {
        this.dialog = false
        setTimeout(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        }, 300)
      },

      save () {
        if (this.editedIndex > -1) {
          Object.assign(this.desserts[this.editedIndex], this.editedItem)
        } else {
          this.desserts.push(this.editedItem)
        }
        this.close()
      },
      async refresh() {
          this.loading=true
        let df = await getMaintenanceRecords({
          facility_name: this.$store.state.pointsListStore.pointsList.facility_name,
            date_range:this.range
        })
        this.rawDesserts = df['result']
          this.refineDeserts();
          this.loading=false
          this.close()
      },
        refineDeserts(){
          if(this.showMineOnly){
              this.desserts=this.rawDesserts.filter(x=>x.assigned_to==this.username||x.assigned_by==this.username)

          } else {
              this.desserts=[...this.rawDesserts]

          }
        },
        exportMR() {
            exportCSV(this.desserts)
        },
    }
  }
</script>

<style scoped>

</style>
